/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { messages } from '@replai-platform/sdk';
import * as SDK from '@replai-platform/sdk';
import { MultiSelectDropDownOption } from '@replai-platform/ui-components';
import { api } from '../../../api';
import { FiltersState } from '../../../store/filters';
import { COUNTRY_GROUP_OPTION_ID_PREFIX, getCountryLabel, groupCountries } from '../../../utils/countryGroups';

export async function fetchCountries(projectId: SDK.UUID, currentFiltering: FiltersState) {
  return api.countries
    .getCountriesMetrics({
      projectIds: [projectId],
      metrics: [SDK.Metrics.SPEND] as SDK.Metrics[],
      orderBy: {
        condition: SDK.OrderByCondition.DESC_NULLS_LAST,
        value: SDK.Metrics.SPEND,
      },
      metricsFilters: {
        // Filter only by date range. This is important to guarantee good performance and to ensure results are
        // ordered by spend according to the data in the selected time range.
        ...(({ dateEndTimestamp, dateStartTimestamp }) => ({ dateEndTimestamp, dateStartTimestamp }))(
          api.filterConverter.getMetricsFilters(currentFiltering)
        ),
        countriesToConsider: [],
        countriesToExclude: ['ALL'],
      },
    })
    .then((values: SDK.GetCountriesMetricsResponse) => {
      // Countries are kept sorted by spend so that, within each geo group, the top markets show up first
      const countries = values.countriesMetrics
        .sort(
          (a: { country: string; metrics: SDK.Metric }, b: { country: string; metrics: SDK.Metric }) =>
            (b.metrics.spend ?? 0) - (a.metrics.spend ?? 0)
        )
        .map((entry) => entry.country);

      // When nothing is selected yet the filter stands for "every country", so everything gets checked
      const hasSelection = countries.some((country) => currentFiltering.countries?.includes(country));
      const isCountrySelected = (country: string) =>
        !hasSelection || !!currentFiltering.countries?.includes(country);

      return [
        {
          id: 'All',
          label: 'All',
          isAllOption: true,
          type: 'option',
          selected: countries.every(isCountrySelected),
        },
        ...groupCountries(countries).flatMap((group) => [
          {
            id: `${COUNTRY_GROUP_OPTION_ID_PREFIX}${group.id}`,
            label: group.label,
            isGroupOption: true,
            groupId: group.id,
          },
          ...group.countries.map((country) => ({
            id: country,
            label: country ? getCountryLabel(country) : messages.NOT_AVAILABLE,
            type: 'option',
            groupId: group.id,
            selected: isCountrySelected(country),
          })),
        ]),
      ] as MultiSelectDropDownOption[];
    });
}
